import { render, staticRenderFns } from "./c-teleport.vue?vue&type=template&id=2a26f7a9&scoped=true"
import script from "./c-teleport.vue?vue&type=script&lang=js"
export * from "./c-teleport.vue?vue&type=script&lang=js"
import style0 from "./c-teleport.vue?vue&type=style&index=0&id=2a26f7a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a26f7a9",
  null
  
)

export default component.exports